import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { SplitScreen } from "@/components/landing/SplitScreen";
import { Chapters } from "@/components/landing/Chapters";
import { Solution } from "@/components/landing/Solution";
import { Social } from "@/components/landing/Social";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC] text-slate-700 font-body selection:bg-indigo-600 selection:text-white">
      <Nav />
      <main>
        <Hero />
        <SplitScreen />
        <Chapters />
        <Solution />
        <Social />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
